import { render, staticRenderFns } from "./NavListItem.vue?vue&type=template&id=2ba93f94&scoped=true&"
import script from "./NavListItem.vue?vue&type=script&lang=ts&"
export * from "./NavListItem.vue?vue&type=script&lang=ts&"
import style0 from "./NavListItem.vue?vue&type=style&index=0&id=2ba93f94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba93f94",
  null
  
)

export default component.exports